import React, { useEffect, useState } from 'react';
import { Column } from '@smartplatform/ui';
import { ModelTable } from 'root/admin/components';
import store from '../../store';
const SubscriptionList = ({ rootPath, path }) => {
	const [options, setOptions] = useState();

	useEffect(() => {
		const init = async () => {
			const roles = await store.model.user.getRoleNames();
			//убрано чтобы роль dispatches могла видеть все сообщения
			// const where = roles.find(role => role === 'admin') ? {} : { ownerId: store.model.user.id };

			setOptions({
				// where,
				include: ['recipients', 'owner'],
				order: 'createdAt DESC',
			});
		};
		init();
	}, []);

	const computedReceived = record => {
		const recipients = record.recipients();
		const checked = recipients.filter(e => e.checked);
		return (
			<div>
				{checked.length} / {recipients.totalCount}
			</div>
		);
	};

	const computedSender = record => (
		<>
			{record.lastName} {record.firstName || ''} {record.middleName || ''}
		</>
	);

	if (!options) {
		return <div>...</div>;
	}
	return (
		<div>
			<h3> Сообщения депутатам </h3>
			<ModelTable model="Dispatch" options={options} rootPath={rootPath} path={path}>
				<Column property="createdAt" label="Создано" />
				<Column relation="owner" computed={computedSender} label="ФИО отправителя" />
				<Column property="name" label="Заголовок" />
				<Column property="sended" label="Разослано" />
				<Column label="Получено / Всего получателей" computed={computedReceived} />
			</ModelTable>
		</div>
	);
};

export default SubscriptionList;
